import { MLSListing, isDefined } from '@aloft/toolkit-shared';
import { Flex } from '@aloft/toolkit-sui';

import { useRef } from 'react';

import { LoadingScreen } from '../../components/LoadingScreen/LoadingScreen.tsx';
import { useStreetView } from '../../hooks/googleMaps/useStreetView.ts';
import { NoData } from './NoData.tsx';

export const Tkv2MlsStreetView = ({
  isPopout,
  listingData,
  address,
}: {
  isPopout: boolean;
  listingData: MLSListing;
  address: string;
}) => {
  const streetViewRef = useRef<HTMLDivElement>(null);

  const position =
    isDefined(listingData.Latitude) && isDefined(listingData.Longitude)
      ? { lat: listingData.Latitude, lng: listingData.Longitude }
      : undefined;

  const status = useStreetView(streetViewRef, address, position);

  if (!position && !address) return <NoData text="No property location available" />;

  let content = null;

  if (status === 'pending') content = <LoadingScreen what="Streetview" />;
  if (status === 'error') {
    content = <NoData text="Google Street View is not available for this property" />;
  }

  return (
    <Flex
      ref={streetViewRef}
      height="100%"
      width="100%"
      position="absolute"
      overflow="hidden"
      top={isPopout ? '2.5rem' : '0'}
    >
      {content}
    </Flex>
  );
};
